import React, { useRef } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, registerables } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels, ...registerables);

function DoughnutChart({ data }) {
	const chartRef = useRef(null);
	const options = {
		cutoutPercentage: 40,
		maintainAspectRatio: false,
		responsive: true,
		plugins: {
			legend: {
				onHover: (evt, legendItem) => {
					const chart = chartRef.current;
					if (chart) {
						const activeElement = {
							datasetIndex: 0,
							index: legendItem.index,
						};
						chart.setActiveElements([activeElement]); // to also show thick border
						chart.tooltip.setActiveElements([activeElement]);
						chart.update();
					}
				},
				position: "right",
				onClick: (e) => e.stopPropagation(),
				labels: {
					boxWidth: 13,

					// This ensures all labels show regardless of data value
					filter: () => true,
					generateLabels: (chart) => {
						const datasets = chart.data.datasets;
						console.log({ datasets });
						const MAX_LABEL_LENGTH = 15;
						return datasets[0]?.data.map((value, index) => ({
							text: chart.data.labels[index].length > MAX_LABEL_LENGTH ? chart.data.labels[index].substring(0, MAX_LABEL_LENGTH) + "..." : chart.data.labels[index],
							fillStyle: datasets[0]?.backgroundColor[index],
							strokeStyle: datasets[0]?.backgroundColor[index],
							tooltip: `This is ${chart.data.labels[index]}`,
							// lineWidth: datasets[0]?.borderWidth,
							// hidden: value === 0,
							index: index,
						}));
					},
				},
			},
			title: {
				display: false,
				text: "Chart.js Line Chart",
			},
			datalabels: {
				color: "#fff", // Set the color of the labels
				formatter: (value, context) => {
					return value > 0 ? value : ""; // Only display value if greater than 0
				},
				// Only show labels for segments with data > 0
				display: (context) => context.dataset.data[context.dataIndex] > 0,
			},
			tooltip: {
  				callbacks: {
    				title: function () {
      					return []; // Remove the default title line
    				},
    				label: function (tooltipItem) {
      					const label = tooltipItem.label || "";
      					const value = tooltipItem.raw;
      					return ` ${label}: ${value}`;
    				},
  				},
			},
		},
	};

	const _data = {
		labels: ["International", "Domestic"],
		datasets: [
			{
				label: "# of Votes",
				data: [12, 19],
				backgroundColor: ["#FE6669", "#FF891A"],
				borderColor: ["#FE6669", "#FF891A", "#1EBFC3"],
				borderWidth: 1,
				radius: "100%",
				cutout: "60%",
			},
		],
	};

	return (
		<div
			style={{
				height: "100%",
				width: "100%",
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
				maxHeight: "340px",
				overflow: "auto",
			}}
		>
			<Doughnut
				ref={chartRef}
				data={data ? data : _data}
				options={{
					...options,
				}}
			/>
		</div>
	);
}

export default DoughnutChart;
